import { Injectable } from "@angular/core"

@Injectable({
    providedIn: 'root'
})
export class BackdropService {

    isVisible: boolean

    constructor() {}

    show() {
        this.isVisible = true
    }

    hide() {
        this.isVisible = false
    }
}